'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OptInFeedbackSuccessMessage = require('./components/OptInFeedbackSuccessMessage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OptInFeedbackSuccessMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-feedback-success-message/index.js
// module id = 1437
// module chunks = 1